
import { submitLead, trackEvent } from '../../../utils/leads';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FiFacebook, FiTwitter, FiLinkedin, FiInstagram, FiYoutube,
  FiMail, FiPhone, FiMapPin, FiSend, FiArrowRight, FiCheckCircle
} from 'react-icons/fi';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [subError, setSubError] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubLoading(true);
    setSubError('');
    try {
      const result = await submitLead({
        full_name: email.split('@')[0],
        email,
        subject: 'Newsletter Subscription',
        message: 'Subscribed to newsletter from footer',
        enquiry_type: 'newsletter',
        source: 'website_footer_newsletter',
        priority: 'low',
      });
      if (result.ok) {
        setSubscribed(true);
        setEmail('');
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        setSubError(result.network ? 'Network error. Please try again.' : 'Subscription failed. Please try again.');
      }
    } finally {
      setSubLoading(false);
    }
  };

  const currentYear = new Date().getFullYear();

 
  const footerSections = {
    company: {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Contact', path: '/contact' },
      ]
    },
    product: {
      title: 'Product',
      links: [
        { name: 'All Features', path: '/features' },
        // { name: 'Pricing', path: '/pricing' },
        { name: 'Request Demo', path: '/demo' },
        // { name: 'Download Apps', path: '/download' },
      ]
    },
    solutions: {
      title: 'Solutions',
      links: [
        { name: 'AI School Management System', path: '/ai-school-management-system' },
        { name: 'School Management Software', path: '/solutions/schools' },
        { name: 'College Management System', path: '/solutions/college' },
        { name: 'Tuition & Coaching Centres', path: '/solutions/tuition' },
        { name: 'Online Colleges', path: '/solutions/universities' },
        { name: 'Learning Management System', path: '/solutions/lms' },
      ]
    },
    features: {
      title: 'Features',
      links: [
        { name: 'Academic Management', path: '/features/academic-management' },
        { name: 'Student Management', path: '/features/student-information-system' },
        { name: 'Fee Management', path: '/features/fees-management' },
        { name: 'Staff Management', path: '/features/staff-management' },
        { name: 'Library Management', path: '/features/library-management' },
        { name: 'Transport Management', path: '/features/transportation-management' },
        { name: 'Hostel Management', path: '/features/hostel-management' },
        { name: 'Timetable Management', path: '/features/timetable-management' },
        { name: 'Communication Tools', path: '/features/communication' },
        { name: 'Reports & Analytics', path: '/features/reports-analytics' },
        { name: 'Accounting & Finance', path: '/features/accounting-finance' },
        { name: 'Security & Privacy', path: '/features/security-privacy' },
        { name: 'Learning Management System', path: '/features/learning-management-system' },
      ]
    },
    resources: {
      title: 'Resources',
      links: [
        { name: 'Blog', path: '/blog' },
        { name: 'Help Center', path: '/help' },
      ]
    },
    support: {
      title: 'Support',
      links: [
        { name: 'Help Center', path: '/help' },
        { name: 'Contact Support', path: '/contact' },
        { name: 'System Status', path: '/status' },
        { name: 'Report Issue', path: '/contact' },
      ]
    },
    legal: {
      title: 'Legal',
      links: [
        { name: 'Legal Center', path: '/legal' },
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Terms and Conditions', path: '/terms' },
        { name: 'Refund Policy', path: '/refund-policy' },
        { name: 'Cookie Policy', path: '/cookie-policy' },
        { name: 'Security and Trust', path: '/data-security' },
      ]
    }
  };

const socialLinks = [
  {
    icon: FiFacebook,
    url: 'https://www.facebook.com/profile.php?id=61588557411943',
    name: 'Facebook',
    color: 'hover:bg-blue-600'
  },
  {
    icon: FiTwitter,
    url: 'https://x.com/ProSolutionsERP',
    name: 'Twitter',
    color: 'hover:bg-sky-500'
  },
  {
    icon: FiLinkedin,
    url: 'https://www.linkedin.com/company/prosolutionerp/',
    name: 'LinkedIn',
    color: 'hover:bg-blue-700'
  },
  {
    icon: FiInstagram,
    url: 'https://www.instagram.com/pro_solution_erp?igsh=MWYxYWF3OHh1OW91YQ==',
    name: 'Instagram',
    color: 'hover:bg-pink-600'
  },
  {
    icon: FiYoutube,
    url: 'https://www.youtube.com/channel/UCAGpk6bllP0Jmu8--2ESXLQ',
    name: 'YouTube',
    color: 'hover:bg-red-600'
  }
];

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  return (
    <footer className="relative bg-white dark:bg-gray-900 overflow-hidden">
      
      {/* Top Wave Design */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg className="relative block w-full h-20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path 
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" 
            className="fill-gray-50 dark:fill-gray-800"
          ></path>
        </svg>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50">
        <motion.div 
          className="absolute top-20 right-10 w-72 h-72 bg-gradient-to-br from-primary-400/20 to-secondary-400/20 rounded-full blur-3xl"
          animate={{
            y: [-20, 20, -20],
            x: [0, 30, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div 
          className="absolute bottom-20 left-10 w-96 h-96 bg-gradient-to-br from-secondary-400/20 to-primary-400/20 rounded-full blur-3xl"
          animate={{
            y: [20, -20, 20],
            x: [0, -30, 0],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1
          }}
        />
      </div>

      <div className="relative z-10 pt-24">
        
        {/* Newsletter Section - Top Center */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-16">
          <motion.div 
            className="mx-auto"
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="relative bg-gradient-to-br from-primary-600 to-secondary-600 dark:from-primary-500 dark:to-secondary-500 rounded-3xl p-8 md:p-12 shadow-2xl overflow-hidden">
              
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <motion.div 
                  className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-32 translate-x-32"
                  animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 90, 0]
                  }}
                  transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                />
                <motion.div 
                  className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-24 -translate-x-24"
                  animate={{
                    scale: [1, 1.2, 1],
                    rotate: [0, -90, 0]
                  }}
                  transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                />
              </div>

              <div className="relative z-10 text-center">
                <motion.h3 
                  className="text-3xl md:text-4xl font-bold text-white mb-4"
                  initial={{ y: -20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                >
                  Stay Updated
                </motion.h3>
                <motion.p 
                  className="text-white/90 text-lg mb-8 max-w-2xl mx-auto"
                  initial={{ y: -20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.5 }}
                >
                  Subscribe to our newsletter for the latest updates, tips, and exclusive content
                </motion.p>
                
                <motion.form 
                  onSubmit={handleSubscribe} 
                  className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.4, duration: 0.5 }}
                >
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="flex-1 px-6 py-4 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30 transition-all text-lg"
                    required
                  />
                  
                  <motion.button
                    type="submit"
                    disabled={subscribed || subLoading}
                    className={`px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap min-w-[180px] ${
                      subscribed
                        ? 'bg-green-500 text-white shadow-lg'
                        : subLoading
                        ? 'bg-white/70 text-primary-400 shadow-lg cursor-not-allowed'
                        : 'bg-white text-primary-600 hover:bg-gray-50 shadow-lg hover:shadow-xl'
                    }`}
                    whileHover={{ scale: (subscribed || subLoading) ? 1 : 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {subscribed ? (
                      <>
                        <FiCheckCircle className="w-6 h-6" />
                        <span>Subscribed!</span>
                      </>
                    ) : subLoading ? (
                      <span>Subscribing...</span>
                    ) : (
                      <>
                        <span>Subscribe</span>
                        <FiSend className="w-5 h-5" />
                      </>
                    )}
                  </motion.button>
                </motion.form>
                {subError && (
                  <p className="mt-3 text-red-300 text-sm text-center">{subError}</p>
                )}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Main Footer Content */}
        <div className="bg-gray-100 dark:bg-gray-800/50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
            
            {/* Links Grid */}
            <motion.div 
              className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-8 mb-16"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={containerVariants}
            >
              
              {/* Company Info Column */}
              <motion.div 
                className="col-span-2 md:col-span-3 lg:col-span-2"
                variants={itemVariants}
              >
                <Link to="/" className="inline-flex items-center space-x-3 mb-6 group">
                  <motion.div 
                    className="w-14 h-14 flex items-center justify-center shadow-lg rounded-xl overflow-hidden bg-white"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <img src="/prologo.jpeg" alt="Logo" className="w-full h-full object-cover" />
                  </motion.div>
                  <div>
                    <h3 className="text-2xl font-heading font-bold text-gray-900 dark:text-white">PRO SOLUTIONS</h3>
                    <p className="text-sm text-primary-600 dark:text-primary-400 font-medium">ERP System</p>
                  </div>
                </Link>
                
                <p className="text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
                  Complete school management solution for modern educational institutions. Transform your operations with our powerful ERP system.
                </p>

                {/* Contact Info */}
                <div className="space-y-3">
                  <motion.a 
                    href="mailto:info@prosolutionserp.com" 
                    className="flex items-center space-x-3 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors group"
                    whileHover={{ x: 5 }}
                  >
                    <div className="w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center group-hover:bg-primary-600 group-hover:text-white transition-all">
                      <FiMail className="w-5 h-5" />
                    </div>
                    <span className="text-sm">info@prosolutionserp.com</span>
                  </motion.a>
                  
                  <motion.a 
                    href="tel:+918111064592" 
                    onClick={() => trackEvent('phone_click', { placement: 'footer' })}
                    className="flex items-center space-x-3 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors group"
                    whileHover={{ x: 5 }}
                  >
                    <div className="w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center group-hover:bg-primary-600 group-hover:text-white transition-all">
                      <FiPhone className="w-5 h-5" />
                    </div>
                    <span className="text-sm">+91 8111064592</span>
                  </motion.a>
                  
                  <div className="flex items-start space-x-3 text-gray-600 dark:text-gray-400">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center flex-shrink-0 mt-1">
                      <FiMapPin className="w-5 h-5" />
                    </div>
                    <span className="text-sm">Mysuru, Karnataka, India</span>
                  </div>
                </div>
              </motion.div>

              {/* Other Columns */}
              {Object.entries(footerSections).slice(0, 5).map(([key, section], index) => (
                <motion.div 
                  key={key} 
                  className="space-y-4"
                  variants={itemVariants}
                  custom={index}
                >
                  <h4 className="text-gray-900 dark:text-white font-bold text-base mb-4 relative inline-block">
                    {section.title}
                    <motion.span 
                      className="absolute -bottom-2 left-0 h-1 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-full"
                      initial={{ width: 0 }}
                      whileInView={{ width: 32 }}
                      transition={{ delay: 0.5 + index * 0.1, duration: 0.5 }}
                    />
                  </h4>
                  <ul className="space-y-3">
                    {section.links.map((link, linkIndex) => (
                      <motion.li 
                        key={linkIndex}
                        initial={{ opacity: 0, x: -10 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.6 + linkIndex * 0.05 }}
                      >
                        <Link
                          to={link.path}
                          className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-300 flex items-center group text-sm"
                        >
                          <FiArrowRight className="w-0 group-hover:w-4 opacity-0 group-hover:opacity-100 mr-0 group-hover:mr-2 transition-all duration-300 text-primary-600" />
                          <span>{link.name}</span>
                        </Link>
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              ))}
            </motion.div>

            {/* Bottom Section */}
            <motion.div 
              className="pt-8 border-t border-gray-300 dark:border-gray-700"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, duration: 0.5 }}
            >
              <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0 gap-6">
                
                {/* Copyright */}
                <div className="text-gray-600 dark:text-gray-400 text-sm text-center lg:text-left">
                  <p>© {currentYear} <span className="text-gray-900 dark:text-white font-semibold">PRO SOLUTIONS ERP</span>. All rights reserved.</p>
                  <p className="mt-1">Made with <span className="text-red-500">❤</span> for Educational Institutions</p>
                </div>

                {/* Social Links */}
                <div className="flex items-center space-x-3">
                  {socialLinks.map((social, index) => (
                    <motion.a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-11 h-11 rounded-xl bg-gray-200 dark:bg-gray-700 flex items-center justify-center transition-all duration-300 group relative overflow-hidden shadow-md"
                      aria-label={social.name}
                      initial={{ scale: 0, rotate: -180 }}
                      whileInView={{ scale: 1, rotate: 0 }}
                      transition={{ delay: index * 0.1, duration: 0.5, ease: "backOut" }}
                      whileHover={{ scale: 1.1, y: -5 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      <span className="absolute inset-0 bg-gradient-to-br from-primary-600 to-secondary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                      <social.icon className="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-white relative z-10 transition-colors" />
                    </motion.a>
                  ))}
                </div>

                {/* Back to Top */}
                <motion.button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="group flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white rounded-xl transition-all duration-300 shadow-lg"
                  whileHover={{ scale: 1.05, boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)" }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="text-sm font-medium">Back to Top</span>
                  <motion.svg 
                    className="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                    whileHover={{ y: -2 }}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </motion.svg>
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
